import { Resource } from 'react-admin'
import { ComponentType } from 'react'
import { debug } from '../test'
import { Permissions } from '../types/apiTypes'
import employeeResource from './Employees'
import conversationResource from './Conversation'
import Settings from '../pages/Settings'

interface ResourceConfig {
  name: string;
  label: string;
  scopes: string[];
  list?: ComponentType<any>;
  edit?: ComponentType<any>;
  show?: ComponentType<any>;
  create?: ComponentType<any>;
}

const resourceDefinitions: ResourceConfig[] = [
  {
    name: 'conversation',
    label: 'Gesprekken',
    scopes: ['labs:all'],
    list: conversationResource.list,
    edit: conversationResource.edit,
  },
  {
    name: 'employee',
    label: 'Medewerkers',
    scopes: ['labs:all'],
    list: employeeResource.list,
    show: employeeResource.show,
  },
  {
    name: 'settings',
    label: 'Instellingen',
    scopes: ['labs:all'],
    list: Settings,
  },
]

export const resourcesForScopes = ({ scopes }: Permissions): JSX.Element[] => {
  debug && console.log({ scopes })
  if (!scopes || scopes.length === 0) {
    console.warn('No scopes received, returning empty resources')
    return []
  }

  return resourceDefinitions
    .filter((res) => res.scopes.some((scope) => scopes.includes(scope)))
    .map((res) => (
      <Resource
        key={res.name}
        name={res.name}
        options={{ label: res.label }}
        list={res.list}
        edit={res.edit}
        show={res.show}
        create={res.create}
      />
    ))
}